import { render, staticRenderFns } from "./Molecule.vue?vue&type=template&id=5aa465a6&scoped=true&"
import script from "./Molecule.vue?vue&type=script&lang=js&"
export * from "./Molecule.vue?vue&type=script&lang=js&"
import style0 from "./Molecule.vue?vue&type=style&index=0&id=5aa465a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa465a6",
  null
  
)

export default component.exports